import { axiosInstance, axiosInstanceV2 } from "api/services/axiosInstance";
import { PROJECT_URL, ORG_USERS_URL } from "constants/ApiConstants";
import qs from "qs";

const userApi = {
  signIn: () => axiosInstance.post(`oauth/signin`),
  getUserIdAPI: () => axiosInstance.get(`oauth/info`),
  saveSession: () => axiosInstance.post(`accounts/userTracking/SaveSession`),
  closeSession: (sessionId) =>
    axiosInstance.put(`accounts/userTracking/CloseSession/${sessionId}`),
  getOrgData: (organizationId) => axiosInstance.get(`org/${organizationId}`),
  updateUserAPI: (data, cancelToken) =>
    axiosInstance.put(`org`, data, {
      cancelToken,
    }),
  verifyPhoneNumber: (data) => axiosInstance.post(`oauth/phone/verify`, data),
  generateCustomToken: (data) =>
    axiosInstance.post(`oauth/phone/customToken`, data),
  sendEventLog: (data) => axiosInstance.post(`/events/log`, data),
  saveUserProfile: (data) => axiosInstanceV2.put(`accounts/user/profile`, data),
  saveUserProfileV1: (data) => axiosInstance.put(`accounts/user/profile`, data),
  getSettings: () => axiosInstanceV2.get(`settings/app`),
  getIdTypes: () => axiosInstance.get(`verifyAd/IdTypes`),
  verifyAdAccount: (data) => axiosInstance.post(`verifyAd`, data),
  getMyProjectOrdersAPI: (projectId, userId, searchKeys, cancelToken) => {
    let params = {
      ...searchKeys,
      CreatedByUserId: userId,
    };
    return axiosInstance.get(`${PROJECT_URL}/${projectId}/orders`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      cancelToken,
    });
  },
  getUsersInvitationsListAPI: (searchKeys, cancelToken) => {
    return axiosInstance.get(`${ORG_USERS_URL}/invitations`, {
      params: {
        ...searchKeys,
      },
      cancelToken,
    });
  },
  checkUserPhoneNumber: (phoneNumber) => {
    return axiosInstance.get(`${ORG_USERS_URL}/exists`, {
      params: { phoneNumber },
    });
  },
  getInvitationByCodeAPI: (invitationCode) => {
    return axiosInstance.get(
      `${ORG_USERS_URL}/invitation/code/${invitationCode}`
    );
  },
  signUpUserByInvitationAPI: (data) => {
    return axiosInstance.post(`${ORG_USERS_URL}/signup`, data);
  },
  sendUserInvitationAPI: (data) => {
    return axiosInstance.post(`${ORG_USERS_URL}/invite`, data);
  },
  resendUserInvitationAPI: (invitationId) => {
    return axiosInstance.put(
      `${ORG_USERS_URL}/invitation/${invitationId}/resend`
    );
  },
  cancelUserInvitationAPI: (invitationId) => {
    return axiosInstance.put(
      `${ORG_USERS_URL}/invitation/${invitationId}/cancel`
    );
  },
  addAttachment: (file) => axiosInstance.post("api/attachments", file),
};

export default userApi;
